var mcb = mcb || {};

mcb.mobilenavigation =
    mcb.mobilenavigation || new (function () {
        this.init = function () {
            const navbar = document.querySelector(".navbar-mobile");
            if (!navbar) {
                return;
            }

            const toggleMenu = navbar.querySelector(".toggle-menu");
            const menuWrapper = navbar.querySelector(".menu-wrapper");
            const level1Links = navbar.querySelectorAll(".level-1 > li > a");
            const listWrapper2 = navbar.querySelector(".list-wrapper:nth-child(2)");
            const listWrapper3 = navbar.querySelector(".list-wrapper:nth-child(3)");
            const subMenuWrapper2 = listWrapper2.querySelector(".sub-menu-wrapper");
            const subMenuWrapper3 = listWrapper3.querySelector(".sub-menu-wrapper");
            const backOneLevelBtns = navbar.querySelectorAll(".back-one-level");
            const backOneDummy = navbar.querySelectorAll(".back-dummy");

            const isVisibleClass = "is-visible";
            const isActiveClass = "is-active";

            toggleMenu.addEventListener("click", function () {

                if (!this.classList.contains(isVisibleClass)) {
                    listWrapper2.classList.remove(isVisibleClass);
                    listWrapper3.classList.remove(isVisibleClass);
                    const menuLinks = menuWrapper.querySelectorAll("a");
                    for (const menuLink of menuLinks) {
                        menuLink.classList.remove(isActiveClass);
                    }
                }
            });

            for (const level1Link of level1Links) {
                level1Link.addEventListener("click", function (e) {
                    const siblingList = level1Link.nextElementSibling;
                    if (siblingList) {
                        e.preventDefault();
                        this.classList.add(isActiveClass);
                        const cloneSiblingList = siblingList.cloneNode(true);
                        subMenuWrapper2.innerHTML = "";
                        subMenuWrapper2.append(cloneSiblingList);
                        listWrapper2.classList.add(isVisibleClass);
                    }
                });
            }

            listWrapper2.addEventListener("click", function (e) {
                const target = e.target;
                if (
                    target.tagName.toLowerCase() === "a" &&
                    target.nextElementSibling
                ) {
                    const siblingList = target.nextElementSibling;
                    e.preventDefault();
                    target.classList.add(isActiveClass);
                    const cloneSiblingList = siblingList.cloneNode(true);
                    subMenuWrapper3.innerHTML = "";
                    subMenuWrapper3.append(cloneSiblingList);
                    listWrapper3.classList.add(isVisibleClass);
                }
            });

            for (const backOneLevelBtn of backOneLevelBtns) {
                backOneLevelBtn.addEventListener("click", function () {
                    const parent = this.closest(".list-wrapper");
                    parent.classList.remove(isVisibleClass);
                    parent.previousElementSibling
                        .querySelector(".is-active")
                        .classList.remove(isActiveClass);
                });
            }

            for (const backDummy of backOneDummy) {
                backDummy.addEventListener("click", function () {
                    const parent = this.closest(".back-one-level");
                    parent.click();
                });
            }
        };
    })();